import { ProgressRadial, Text } from "@itwin/itwinui-react";
import { CodeEditorStatus } from "../../../types";
import styles from "./StatusOverlay.module.css";

export const StatusOverlay = ({ status }: { status: CodeEditorStatus }) => {

  const message = status === "loading" ? "Initializing TypeScript..." : status === "checking" ? "Checking Types..." : "";

  if (!status)
    return null;

  return (
    <div className={styles.container}>
      <div className={styles.status}>
        <ProgressRadial indeterminate size="x-small" />
        <Text variant="small" isMuted>{message}</Text>
      </div>
    </div>
  )
}